import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import React from 'react';
import PropTypes from 'prop-types';

import Reveal from './Reveal';

const StyledReferences = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(6),
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
  },
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
  },
  gap: theme.spacing(2),
  '.MuiBox-root': {
    background: 'white',
    color: 'black',
    padding: theme.spacing(1),
    borderRadius: '0.5rem',
    height: '75px',
    [theme.breakpoints.up('sm')]: {
      height: '100px',
    },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    'img': {
      width: '90%',
      objectFit: 'contain',
      height: '80%',
      filter: 'grayscale(100%)',
      // filter: 'brightness(0) invert(1)',
      transition: 'filter 0.3s ease-in-out',
      '&:hover': {
        filter: 'grayscale(0%)',
      },
    },
    '&.action': {
      background: theme.palette.background.greenGradient,
      border: `1px solid ${theme.palette.background.brand}`,
      boxShadow: `0 0 0 0 ${theme.palette.background.brand}`,
      '.MuiButton-text': {
        color: theme.palette.text.primary,
        fontFamily: 'Usuzi',
        lineHeight: 1,
        fontSize: 'max(1vw, 10pt)',
        [theme.breakpoints.up('md')]: {
          fontSize: 'max(1vw, 16pt)',
        },
        transition: 'box-shadow 0.6s ease-in-out, transform 0.3s ease-in-out',
        '&:hover': {
          background: 'none',
        },
      },
      '&:hover': {
        boxShadow: `0 0 4px 1px ${theme.palette.background.brand}`,
        transform: 'scale(1.05)',
      },
    }
  },
}));

const References = ({ children = null, ...props }) => {
  const referenceChildren = React.Children.toArray(children);

  return (
    <StyledReferences {...props}>
      {referenceChildren.map((child, index) => (
        <Reveal
          key={child.key ?? index}
          asChild
          delay={index * 60}
          liftOnReveal
        >
          {child}
        </Reveal>
      ))}
    </StyledReferences>
  );
};

References.propTypes = {
  children: PropTypes.node,
};

export default References;
